import { render, staticRenderFns } from "./TransactionType.vue?vue&type=template&id=25847b48&scoped=true"
import script from "./TransactionType.vue?vue&type=script&lang=js"
export * from "./TransactionType.vue?vue&type=script&lang=js"
import style0 from "./TransactionType.vue?vue&type=style&index=0&id=25847b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25847b48",
  null
  
)

export default component.exports